<div class="paralax-wrapper" #parallaxContainer [ngStyle]="bgImage">
    <ul id="scene">
         <ng-content></ng-content>
    </ul>
</div>

<ea-btn-nav-background></ea-btn-nav-background>
